//Angular
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/share';

import { CacheService  } from '../core/cache.service';
import { ApiService  } from '../core/api.service';
import { Mappings} from '../../shared/mapping'
import { AuthService } from '../core/auth.service';

@Injectable()
export class CmsContentService 
{
     constructor
     (
      public _api: ApiService, 
      public _cache: CacheService, 
      private authService: AuthService,
      private mappings: Mappings
    ) {}

  //whatever domain/feature method name
  getCmsPageById(lang:string, pageId: string) 
  {
    let customerId = this.authService.GetUserId();
    
    let url =  this.mappings.Web_Api_Menu_GetCmsPageById
    .replace('{customerid}',customerId)
    .replace('{lang}',lang)
    .replace('{id}',pageId);

    return this._api.get(url);
  }

  getCmsPageByUrl(lang:string, pageUrl: string) 
  {
    let customerId = this.authService.GetUserId();

    let url =  this.mappings.Web_Api_Menu_GetCmsPageByUrl
    .replace('{customerid}',customerId)
    .replace('{lang}',lang)
    .replace('{url}',pageUrl);

    return this._api.get(url);
  }  
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/services/cms/cms-content.service.ts